import { render, staticRenderFns } from "./AllDocumentsList.vue?vue&type=template&id=2cd6f4e1"
import script from "./AllDocumentsList.vue?vue&type=script&lang=js"
export * from "./AllDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./AllDocumentsList.vue?vue&type=style&index=0&id=2cd6f4e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports